document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.c_staff-list[data-leeep-tag-id], .c_staff-coordinate[data-leeep-tag-id]');
  if (sections.length === 0) return;

  const observerMap = new WeakMap();
  const reorderedMap = new WeakMap();
  const staffBrandNames = new Set([
    'すべて',
    'Tabioオンラインストア',
    '靴下屋',
    'Tabio',
    'Tabio MEN',
    '靴下屋UPDATE',
    'ｍaison peca',
    'Tabio本部'
  ]);

  sections.forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    initSection(section);
  });

  function initSection(section) {
    const tagId = section.dataset.leeepTagId;
    const area = section.querySelector('[data-leeep-area]');

    const renderLeeep = (id) => {
      if (!area || !id || typeof LeeepCite === 'undefined') return;
      area.textContent = '';
      const div = document.createElement('div');
      div.id = 'leeep-tag-' + String(id);
      area.appendChild(div);
      LeeepCite.init({ tag_id: String(id) });
    };

    const waitForLeeep = (count = 0) => {
      if (typeof LeeepCite !== 'undefined') { renderLeeep(tagId); return; }
      if (count > 50) {
        if (area) area.textContent = 'コンテンツの読み込みに失敗しました。ページを再読み込みしてください。';
        return;
      }
      setTimeout(() => waitForLeeep(count + 1), 100);
    };

    // 詳細ページのハッシュタグから sessionStorage 経由で受け取った絞り込み条件（ワンショット）。
    // 旧実装は ?leeep_filter= をURLで渡していたが、LEEEP の絞り込み送信がフルページ遷移で
    // 元クエリを保持するため値がURLに残り続け、「条件をクリア→絞り込む」のリロードで再適用されてしまう。
    // そのため sessionStorage に変更し、読み取った時点で削除して二度と再適用しないようにする。
    let pendingFilterValues = [];
    try {
      const rawPending = sessionStorage.getItem('c_leeepPendingFilters');
      if (rawPending) {
        const parsed = JSON.parse(rawPending);
        // 3一覧（コーデ/ランキング/ブログ）でキーを共有しているため、target が自分宛ての
        // ときだけ消費する。別一覧宛ては removeItem せず残し、正しい一覧で後から消費できるようにする。
        const myTarget = section.classList.contains('c_staff-list') ? 'staff-ranking' : 'staff-coordinate';
        if (parsed && parsed.target === myTarget && Array.isArray(parsed.values)) {
          sessionStorage.removeItem('c_leeepPendingFilters');
          pendingFilterValues = parsed.values.filter((v) => typeof v === 'string' && v);
        }
      }
    } catch (e) {
      pendingFilterValues = [];
    }
    if (pendingFilterValues.length > 0) {
      section.dataset.pendingFilter = 'true';
    }

    if (tagId) waitForLeeep();

    if (pendingFilterValues.length > 0) {
      const releasePendingFilter = () => {
        delete section.dataset.pendingFilter;
      };

      const tryApplyPendingFilter = () => {
        const inputs = [...section.querySelectorAll('.LeeepSearchFilterValueInput')];
        const submitBtn = section.querySelector('.LeeepSearchFilterSubmitButton');
        if (inputs.length === 0 || !submitBtn) return false;

        let matched = false;
        pendingFilterValues.forEach((val) => {
          const target = (val || '').trim();
          const input = inputs.find((i) => {
            if ((i.value || '').trim() === target) return true;
            const label = i.closest('.LeeepSearchFilterLabel');
            const nameEl = label && label.querySelector('.LeeepSearchFilterValueName');
            return !!nameEl && nameEl.textContent.trim() === target;
          });
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
            matched = true;
          }
        });
        if (!matched) return false;

        const onPostSubmitRender = () => {
          document.removeEventListener('onLeeepContentsRendered', onPostSubmitRender);
          requestAnimationFrame(releasePendingFilter);
        };
        document.addEventListener('onLeeepContentsRendered', onPostSubmitRender);
        setTimeout(() => {
          document.removeEventListener('onLeeepContentsRendered', onPostSubmitRender);
          releasePendingFilter();
        }, 10000);

        submitBtn.click();

        return true;
      };

      if (!tryApplyPendingFilter()) {
        const filterObserver = new MutationObserver(() => {
          if (tryApplyPendingFilter()) filterObserver.disconnect();
        });
        filterObserver.observe(section, { childList: true, subtree: true });
        setTimeout(() => {
          filterObserver.disconnect();
          releasePendingFilter();
        }, 10000);
      }
    }

    waitAndSetupSp(section);

    document.addEventListener('onLeeepContentsRendered', () => {
      filterStaffBrands(section);
      setupFilterShowMore(section);
    });
  }

  function filterStaffBrands(section) {
    section.querySelectorAll('.LeeepSearchFilterKey').forEach((key) => {
      const keyName = key.querySelector('.LeeepSearchFilterKeyName');
      if (!keyName || keyName.textContent.trim() !== 'ブランド') return;
      key.querySelectorAll('.LeeepSearchFilterLabel').forEach((label) => {
        const valueName = label.querySelector('.LeeepSearchFilterValueName');
        const name = valueName ? valueName.textContent.trim() : '';
        label.hidden = !!name && !staffBrandNames.has(name);
      });
    });
  }

  function waitAndSetupSp(section) {
    const trySetup = () => {
      const leeepFilter = section.querySelector('.LeeepSearchFilter');
      const filterKeys = leeepFilter ? leeepFilter.querySelectorAll('.LeeepSearchFilterKey') : [];
      if (filterKeys.length === 0) return false;
      filterStaffBrands(section);
      setupDesktopSort(section);
      setupSpDrawers(section);
      setupFilterShowMore(section);
      setupAccordionAnimation(section);
      return true;
    };

    if (trySetup()) return;

    const observer = new MutationObserver(() => {
      if (trySetup()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 60000);
  }

  document.addEventListener('onLeeepContentsRendered', async (event) => {
    const renderedTagId = String(event && event.detail && event.detail.tag_id || '');
    if (!renderedTagId) return;

    const root = document.querySelector('#leeep-embedded-' + renderedTagId);
    if (!root) return;

    const section = root.closest('.c_staff-list, .c_staff-coordinate');
    if (!section) return;
    const listType = section.classList.contains('c_staff-list') ? 'staff' : 'post';

    const staffOuter = root.querySelector('.LeeepStaffListScrollOuter');
    if (staffOuter) root.classList.add('is-leeep-staff-list');

    applyColorAttributes(section);

    if (!observerMap.has(section)) {
      const filterContainer = section.querySelector('.LeeepSearchFilterContainer');
      if (filterContainer) {
        const observer = new MutationObserver(() => applyColorAttributes(section));
        observer.observe(filterContainer, { childList: true, subtree: true });
        observerMap.set(section, observer);
      }
    }

    cleanupPagerPersistent(root);

    if (listType === 'staff') {
      syncStaffSortState(section);
      assignRankNumbers(root);
      // LEEEP側は描画完了イベント後にもスタッフDOMを差し替える場合があるため、
      // 人気順の順位表示を描画直後に再同期する。
      [50, 250, 800].forEach((delay) => {
        setTimeout(() => assignRankNumbers(root), delay);
      });
      const staffs = event.detail && event.detail.staffs;
      if (staffs && staffs.length) reorderStaffInfo(root, staffs, reorderedMap);
    }

    if (listType === 'post') {
      mergePostBrandShop(root);
      const staffPosts = event.detail && event.detail.staff_posts;
      if (staffPosts && staffPosts.length) {
        await insertPostProductName(root, staffPosts);
        await insertPostHeightFoot(root, staffPosts);
      }
    }
  });

  function mergePostBrandShop(root) {
    root.querySelectorAll('.LeeepPost').forEach((container) => {
      if (container.dataset.__brandShopMerged) return;
      const brandEl = container.querySelector('.LeeepListUserBrand');
      if (!brandEl) return;
      const shopEl = container.querySelector('.LeeepListUserShop');
      const brandText = (brandEl.textContent || '').trim();
      const shopText = shopEl ? (shopEl.textContent || '').trim() : '';
      if (brandText || shopText) {
        brandEl.textContent = '';
        const maker = document.createElement('span');
        maker.textContent = brandText;
        brandEl.appendChild(maker);
        if (shopText) {
          brandEl.appendChild(document.createTextNode(' '));
          const shop = document.createElement('span');
          shop.textContent = shopText;
          brandEl.appendChild(shop);
        }
      }
      container.dataset.__brandShopMerged = '1';
    });
  }

  function applyColorAttributes(section) {
    section.querySelectorAll('.LeeepSearchFilterLabel').forEach((label) => {
      if (label.dataset.colorValue) return;
      const input = label.querySelector('.LeeepSearchFilterValueInput');
      if (!input) return;
      const val = input.value || '';
      if (val.startsWith('パーソナルカラー,')) {
        const colorName = val.split(',')[1];
        if (colorName) label.dataset.colorValue = colorName;
      }
    });
  }

  function cleanupPagerPersistent(root) {
    cleanupPager(root);
    [50, 150, 400, 800, 1500].forEach(delay => {
      setTimeout(() => cleanupPager(root), delay);
    });
  }

  function cleanupPager(root) {
    const pagerItems = [...root.querySelectorAll('.LeeepPagerItem')];
    if (!pagerItems.length) return;

    const chevronItems = pagerItems.filter(item => item.querySelector('.LeeepPagerChevron'));
    const pageNumberItems = pagerItems.filter(item => !item.querySelector('.LeeepPagerChevron'));
    const pager = root.querySelector('.LeeepPager');

    if (pageNumberItems.length <= 1) {
      if (pager) pager.style.display = 'none';
      return;
    }

    const currentItem = root.querySelector('.LeeepPagerItemCurrent');
    if (!currentItem) return;

    const currentIdx = pageNumberItems.indexOf(currentItem);
    if (currentIdx === -1) return;

    if (currentIdx === 0 && pageNumberItems[0]) {
      const firstPage = pageNumberItems[0];
      chevronItems.forEach(chev => {
        if (chev.compareDocumentPosition(firstPage) & Node.DOCUMENT_POSITION_FOLLOWING) {
          chev.remove();
        }
      });
    }

    if (currentIdx === pageNumberItems.length - 1) {
      const lastPage = pageNumberItems[pageNumberItems.length - 1];
      chevronItems.forEach(chev => {
        if (lastPage.compareDocumentPosition(chev) & Node.DOCUMENT_POSITION_FOLLOWING) {
          chev.remove();
        }
      });
    }
  }

  function assignRankNumbers(root) {
    const section = root.closest('.c_staff-list');
    const isPopularitySort = !!section && section.classList.contains('is-popularity-sort');
    const currentPage = root.querySelector('.LeeepPagerItemCurrent');
    const isFirstPage = !currentPage || currentPage === root.querySelector('.LeeepPagerItem:not(:has(.LeeepPagerChevron))');
    root.querySelectorAll('.LeeepStaffListScrollInner > .LeeepStaffListLink').forEach((link, idx) => {
      const rankEl = link.querySelector('.LeeepStaffRankNumber');
      if (!rankEl) return;
      if (!isPopularitySort) {
        rankEl.style.display = 'none';
      } else if (isFirstPage) {
        rankEl.textContent = String(idx + 1);
        rankEl.style.display = 'flex';
      } else {
        rankEl.style.display = 'none';
      }
    });
  }

  function getStaffSortInput(section) {
    return [...section.querySelectorAll('.LeeepSearchFilter input[type="radio"]')].find((input) => {
      const key = input.closest('.LeeepSearchFilterKey');
      const name = key && key.querySelector('.LeeepSearchFilterKeyName');
      return name && name.textContent.trim() === '並び順' && input.checked;
    });
  }

  function syncStaffSortState(section) {
    if (!section || !section.classList.contains('c_staff-list')) return;
    const checked = getStaffSortInput(section);
    const value = checked ? checked.value : 'publish';
    const isPopularity = value === 'pv';
    section.classList.toggle('is-popularity-sort', isPopularity);
    section.querySelectorAll('[data-desktop-sort]').forEach((button) => {
      const active = button.dataset.desktopSort === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function setupDesktopSort(section) {
    if (!section.classList.contains('c_staff-list') || section.dataset.desktopSortReady === 'true') return;
    const buttons = [...section.querySelectorAll('[data-desktop-sort]')];
    if (!buttons.length) return;
    section.dataset.desktopSortReady = 'true';
    syncStaffSortState(section);

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const value = button.dataset.desktopSort;
        const filter = section.querySelector('.LeeepSearchFilter');
        if (!filter || !value) return;
        const input = [...filter.querySelectorAll('input[type="radio"]')].find((candidate) => candidate.value === value);
        if (!input || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncStaffSortState(section);
        const submit = filter.querySelector('.LeeepSearchFilterSubmitButton');
        if (submit) submit.click();
      });
    });
  }

  function reorderStaffInfo(root, staffs, reorderedMap) {
    for (let i = 0; i < staffs.length; i++) {
      const staff = staffs[i];
      if (!staff || !staff.id) continue;

      const linkEl = root.querySelector('.LeeepStaffListLink[data-id="' + staff.id + '"]');
      if (!linkEl || reorderedMap.has(linkEl)) continue;
      reorderedMap.set(linkEl, true);

      const nameEl = linkEl.querySelector('.LeeepStaffListName');
      const heightEl = linkEl.querySelector('.LeeepStaffListHeight');
      const shopEl = linkEl.querySelector('.LeeepStaffListShopName');
      const brandEl = linkEl.querySelector('.LeeepStaffListBrandName');

      if (!nameEl) continue;
      if (brandEl) brandEl.style.display = 'none';

      const props = (staff.staff && staff.staff.properties) || [];
      let footSize = null;
      for (let j = 0; j < props.length; j++) {
        if (props[j] && props[j].key && props[j].key.name === '足のサイズ') {
          footSize = props[j];
          break;
        }
      }

      let heightText = '';
      if (heightEl) heightText = (heightEl.textContent || '').trim();
      else if (staff.height) heightText = String(staff.height) + 'cm';

      let infoText = '';
      if (heightText) infoText += heightText;
      if (heightText && footSize && footSize.value && footSize.value.name) infoText += '/';
      if (footSize && footSize.value && footSize.value.name) infoText += footSize.value.name + 'cm';

      if (heightEl) heightEl.style.display = 'none';

      if (infoText) {
        const infoEl = document.createElement('div');
        infoEl.className = 'LeeepStaffListHeightFoot';
        infoEl.textContent = infoText;
        if (shopEl) shopEl.after(infoEl);
        else nameEl.after(infoEl);
      }

      if (shopEl) nameEl.after(shopEl);
    }
  }

  async function insertPostProductName(root, staffPosts) {
    const websiteId = (typeof LeeepCite !== 'undefined') ? LeeepCite.site_id : '';
    if (!websiteId) return;

    const unprocessed = [];
    for (let i = 0; i < staffPosts.length; i++) {
      const post = staffPosts[i];
      if (!post || !post.id) continue;
      const postEl = root.querySelector('.LeeepPost .LeeepListAnchor[data-id="' + post.id + '"]');
      if (!postEl) continue;
      const parent = postEl.closest('.LeeepPost');
      if (parent && !parent.dataset.__productNameInserted) unprocessed.push(post);
    }
    if (!unprocessed.length) return;

    const postIds = unprocessed.map(p => p.id).join(',');
    try {
      const res = await fetch(LeeepCite.domain + '/v3/posts?website_id=' + websiteId + '&post_id=' + postIds + '&with_products=true');
      if (!res.ok) return;
      const json = await res.json();
      const productsMap = {};
      (json.posts || []).forEach(p => productsMap[p.id] = p.products || []);

      unprocessed.forEach(p => {
        const anchorEl = root.querySelector('.LeeepPost .LeeepListAnchor[data-id="' + p.id + '"]');
        if (!anchorEl) return;
        const parent = anchorEl.closest('.LeeepPost');
        if (!parent || parent.dataset.__productNameInserted) return;
        const products = productsMap[p.id] || [];
        if (!products.length) return;
        const productName = products[0] && products[0].name ? products[0].name : '';
        if (!productName) return;
        const listContent = parent.querySelector('.LeeepListContent');
        if (!listContent) return;
        const nameEl = document.createElement('div');
        nameEl.className = 'LeeepListProductName';
        nameEl.textContent = productName;
        parent.dataset.__productNameInserted = '1';
        listContent.insertBefore(nameEl, listContent.firstChild);
      });
    } catch (e) {
      console.warn('[c_custom-leeep] post product name fetch error', e);
    }
  }

  async function insertPostHeightFoot(root, staffPosts) {
    const websiteId = (typeof LeeepCite !== 'undefined' && LeeepCite.site_id) ? String(LeeepCite.site_id) : '';
    if (!websiteId) return;

    const staffIds = [...new Set(staffPosts.map(p => p && p.post_user ? p.post_user.id : '').filter(Boolean))];
    if (!staffIds.length) return;

    let staffPropsMap = {};
    try {
      const res = await fetch('https://cite.leeep.jp/v3/staffs?website_id=' + websiteId + '&staff_id=' + staffIds.join(','));
      if (res.ok) {
        const json = await res.json();
        (json.staffs || []).forEach(staff => {
          staffPropsMap[staff.id] = (staff.staff && staff.staff.properties) || [];
        });
      }
    } catch (e) {
      console.warn('[c_custom-leeep] post height/foot fetch error', e);
      return;
    }

    staffPosts.forEach(post => {
      if (!post || !post.id || !post.post_user) return;
      const anchorEl = root.querySelector('.LeeepListAnchor[data-id="' + post.id + '"]');
      if (!anchorEl) return;
      const container = anchorEl.closest('.LeeepPost');
      if (!container || container.dataset.__heightFootAdded) return;

      const height = post.post_height || post.post_user.height || '';
      const props = staffPropsMap[post.post_user.id] || [];
      const footSize = props.find(p => p && p.key && p.key.name === '足のサイズ');
      const rawFootSize = footSize && footSize.value && footSize.value.name ? String(footSize.value.name) : '';
      const footSizeText = rawFootSize ? (rawFootSize.endsWith('cm') ? rawFootSize : rawFootSize + 'cm') : '';

      let text = '';
      if (height) text += height + 'cm';
      if (height && footSizeText) text += '/';
      if (footSizeText) text += footSizeText;
      if (!text) return;

      const defaultHeightEl = container.querySelector('.LeeepListUserHeight');
      if (defaultHeightEl) defaultHeightEl.style.display = 'none';

      const brandEl = container.querySelector('.LeeepListUserBrand');
      if (!brandEl) return;

      const infoEl = document.createElement('div');
      infoEl.className = 'LeeepListHeightFoot';
      infoEl.textContent = text;
      brandEl.after(infoEl);
      container.dataset.__heightFootAdded = '1';
    });
  }

  function setupSpDrawers(section) {
    const filterDrawerRoot = section.querySelector('[data-filter-drawer]');
    const sortDrawerRoot = section.querySelector('[data-sort-drawer]');
    const filterBtn = section.querySelector('[data-filter-drawer-toggle]');
    const sortBtn = section.querySelector('[data-sort-drawer-toggle]');
    const sortCurrentEl = section.querySelector('[data-sort-current]');
    if (!filterDrawerRoot || !filterBtn) return;

    const filterBody = filterDrawerRoot.querySelector('[data-drawer-body]');
    const sortBody = sortDrawerRoot ? sortDrawerRoot.querySelector('[data-drawer-body]') : null;
    if (!filterBody) return;

    const leeepFilter = section.querySelector('.LeeepSearchFilter');
    if (!leeepFilter) return;

    // LEEEP 再描画後も最新のチェック状態・店舗階層を使うため、開くたびに再生成する。
    const populateDrawerBody = () => {
      filterBody.innerHTML = '';
      if (sortBody) sortBody.innerHTML = '';
      const currentFilter = section.querySelector('.LeeepSearchFilter');
      if (!currentFilter) return;

      currentFilter.querySelectorAll('.LeeepSearchFilterKey').forEach(key => {
        const name = key.querySelector('.LeeepSearchFilterKeyName');
        if (!name) return;
        const isSort = name.textContent.trim() === '並び順';
        if (isSort && !sortBody) return;
        const target = isSort ? sortBody : filterBody;
        target.appendChild(cloneFilterKeyForDrawer(key));
      });

      [filterBody, sortBody].forEach(container => {
        if (!container) return;
        container.querySelectorAll('.LeeepSearchFilterKey').forEach(key => {
          delete key.dataset.__accordionReady;
        });
        container.querySelectorAll('.LeeepSearchFilterCategoryToggle').forEach(toggle => {
          const category = toggle.closest('.LeeepSearchFilterCategory');
          if (!category) return;
          toggle.setAttribute('aria-expanded', String(category.classList.contains('LeeepSearchFilterCategoryOpen')));
        });
      });

      setupFilterShowMore(section);
      setupAccordionAnimation(section);

      if (sortBody && sortCurrentEl) {
        const checkedSort = sortBody.querySelector('input:checked');
        if (checkedSort) {
          const valueName = checkedSort.closest('.LeeepSearchFilterLabel')?.querySelector('.LeeepSearchFilterValueName');
          if (valueName) sortCurrentEl.textContent = valueName.textContent.trim();
        }
      }
    };
    populateDrawerBody();

    const openDrawer = (drawer, triggerBtn) => {
      populateDrawerBody();
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'true');
      const firstFocusable = drawer.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (firstFocusable) firstFocusable.focus();
    };
    const closeDrawer = (drawer, triggerBtn) => {
      drawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (triggerBtn) triggerBtn.setAttribute('aria-expanded', 'false');
      if (triggerBtn) triggerBtn.focus();
    };

    filterBtn.addEventListener('click', () => openDrawer(filterDrawerRoot, filterBtn));
    if (sortDrawerRoot && sortBtn) {
      sortBtn.addEventListener('click', () => openDrawer(sortDrawerRoot, sortBtn));
    }

    const drawerTriggerMap = [{ drawer: filterDrawerRoot, trigger: filterBtn }];
    if (sortDrawerRoot && sortBtn) drawerTriggerMap.push({ drawer: sortDrawerRoot, trigger: sortBtn });
    drawerTriggerMap.forEach(({ drawer, trigger }) => {
      drawer.querySelector('[data-drawer-close]')?.addEventListener('click', () => closeDrawer(drawer, trigger));
      drawer.querySelector('[data-drawer-overlay]')?.addEventListener('click', () => closeDrawer(drawer, trigger));
      // 再生成されるクローンにも効くよう、ドロワーへイベント委譲する。
      drawer.addEventListener('click', event => {
        const categoryToggle = event.target.closest('.LeeepSearchFilterCategoryToggle');
        if (categoryToggle && drawer.contains(categoryToggle)) {
          event.preventDefault();
          event.stopPropagation();
          const category = categoryToggle.closest('.LeeepSearchFilterCategory');
          if (!category) return;
          const isOpen = category.classList.toggle('LeeepSearchFilterCategoryOpen');
          categoryToggle.setAttribute('aria-expanded', String(isOpen));
          return;
        }

        const header = event.target.closest('.LeeepSearchFilterKeyHeader');
        if (header && drawer.contains(header)) {
          header.closest('.LeeepSearchFilterKey')?.classList.toggle('LeeepSearchFilterItemOpen');
        }
      });
    });

    section.addEventListener('keydown', (e) => {
      const drawers = sortDrawerRoot ? [filterDrawerRoot, sortDrawerRoot] : [filterDrawerRoot];
      const openDrawerEl = drawers.find(d => d.classList.contains('is-open'));
      if (!openDrawerEl) return;

      if (e.key === 'Escape') {
        const trigger = openDrawerEl === filterDrawerRoot ? filterBtn : sortBtn;
        closeDrawer(openDrawerEl, trigger);
        return;
      }

      if (e.key === 'Tab') {
        const panel = openDrawerEl.querySelector('.c_leeep-section__drawer-panel');
        if (!panel) return;
        const focusables = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (focusables.length === 0) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });

    const syncAndSubmit = (inputs) => {
      const currentFilter = section.querySelector('.LeeepSearchFilter');
      if (!currentFilter) return;
      inputs.forEach(input => {
        if (input.type === 'radio' && !input.checked) return;
        const origInputs = currentFilter.querySelectorAll('input[name="' + (input.dataset.cOrigName || input.name) + '"]');
        origInputs.forEach(orig => {
          if (input.type === 'radio') orig.checked = (orig.value === input.value);
          else if (orig.value === input.value) orig.checked = input.checked;
        });
      });
      const submitBtn = currentFilter.querySelector('.LeeepSearchFilterSubmitButton');
      if (submitBtn) submitBtn.click();
    };

    const filterSubmit = filterDrawerRoot.querySelector('[data-filter-submit]');
    if (filterSubmit) {
      filterSubmit.addEventListener('click', () => {
        syncAndSubmit(filterBody.querySelectorAll('input'));
        closeDrawer(filterDrawerRoot, filterBtn);
      });
    }

    if (sortBody && sortDrawerRoot) {
      sortBody.addEventListener('change', (e) => {
        if (!e.target.matches('input')) return;
        syncAndSubmit(sortBody.querySelectorAll('input'));
        const label = e.target.closest('.LeeepSearchFilterLabel');
        const valueName = label && label.querySelector('.LeeepSearchFilterValueName');
        if (valueName && sortCurrentEl) sortCurrentEl.textContent = valueName.textContent.trim();
        closeDrawer(sortDrawerRoot, sortBtn);
      });
    }
  }

  function filterCountsOf(section) {
    const initial = Number(section.dataset.filterInitialCount) || 30;
    const step = Number(section.dataset.filterStepCount) || initial;
    return { initial, step };
  }

  // ドロワー用に複製した絞り込み項目。ラジオは同じ name だとページ内で1グループになり、
  // 複製側の選択が元（PC表示）の選択を外してしまうため、name を変えて元の name は data-c-orig-name に残す。
  function cloneFilterKeyForDrawer(key) {
    const clone = key.cloneNode(true);
    clone.querySelectorAll('input[name]').forEach((input) => {
      input.dataset.cOrigName = input.name;
      input.name = 'c_drawer:' + input.name;
    });
    return clone;
  }

  function filterGroupKeyOf(values) {
    const input = values.querySelector('.LeeepSearchFilterValueInput');
    if (input && input.name) return 'name:' + (input.dataset.cOrigName || input.name);
    const keyEl = values.closest('.LeeepSearchFilterKey');
    const nameEl = keyEl && keyEl.querySelector('.LeeepSearchFilterKeyName');
    return nameEl ? 'label:' + nameEl.textContent.trim() : '';
  }

  function hasCategoryTree(values) {
    return !!values.querySelector('.LeeepSearchFilterCategory');
  }

  function renderFilterValues(section, values) {
    const { initial } = filterCountsOf(section);
    const labels = Array.from(values.querySelectorAll('.LeeepSearchFilterLabel'));
    /* 店舗階層は LEEEP 側のカテゴリ開閉を使う。フラット項目向けの
       件数制限を重ねると、子店舗が途中で隠れて階層が分かりにくくなる。 */
    if (hasCategoryTree(values)) {
      labels.forEach((label) => label.classList.remove('c_is-filter-hidden'));
      values.removeAttribute('data-c-shown');
      const existingButton = values.querySelector('.c_leeep-filter-more');
      if (existingButton) existingButton.remove();
      return;
    }
    const shown = Number(values.dataset.cShown) || initial;

    let hidden = 0;
    labels.forEach((label, i) => {
      const input = label.querySelector('.LeeepSearchFilterValueInput');
      const isHidden = i >= shown && !(input && input.checked);
      label.classList.toggle('c_is-filter-hidden', isHidden);
      if (isHidden) hidden += 1;
    });

    const button = values.querySelector('.c_leeep-filter-more');
    if (!button) return;
    if (hidden <= 0) {
      button.remove();
      return;
    }
    button.textContent = 'さらに表示（残り' + hidden.toLocaleString() + '件）';
  }

  function setupFilterShowMore(section) {
    const { initial, step } = filterCountsOf(section);

    if (section.dataset.__showMoreDelegated !== '1') {
      section.dataset.__showMoreDelegated = '1';
      section.addEventListener('click', (e) => {
        const button = e.target.closest('.c_leeep-filter-more');
        if (!button || !section.contains(button)) return;
        const values = button.closest('.LeeepSearchFilterValues');
        if (!values) return;
        const next = (Number(values.dataset.cShown) || initial) + step;
        const groupKey = filterGroupKeyOf(values);

        const targets = groupKey
          ? Array.from(section.querySelectorAll('.LeeepSearchFilterValues'))
              .filter((el) => filterGroupKeyOf(el) === groupKey)
          : [values];

        targets.forEach((target) => {
          target.dataset.cShown = String(next);
          renderFilterValues(section, target);

          const keyEl = target.closest('.LeeepSearchFilterKey');
          const isOpen = !!keyEl && keyEl.classList.contains('LeeepSearchFilterItemOpen');
          if (isOpen && target.style.height && target.style.height !== 'auto') {
            target.style.height = 'auto';
          }
        });
      });
    }

    section.querySelectorAll('.LeeepSearchFilterValues').forEach((values) => {
      if (hasCategoryTree(values)) {
        renderFilterValues(section, values);
        return;
      }
      if (values.querySelectorAll('.LeeepSearchFilterLabel').length <= initial) return;
      if (!values.dataset.cShown) values.dataset.cShown = String(initial);
      if (!values.querySelector('.c_leeep-filter-more')) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'c_leeep-filter-more';
        values.appendChild(button);
      }
      renderFilterValues(section, values);
    });
  }

  function setupAccordionAnimation(section) {
    section.querySelectorAll('.LeeepSearchFilterKey').forEach((key) => {
      if (key.dataset.__accordionReady) return;
      key.dataset.__accordionReady = '1';

      const values = key.querySelector('.LeeepSearchFilterValues');
      if (!values) return;

      values.style.setProperty('display', 'block', 'important');
      values.style.overflow = 'hidden';
      values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';

      if (key.classList.contains('LeeepSearchFilterItemOpen')) {
        values.style.height = 'auto';
        values.style.marginTop = '24px';
      } else {
        values.style.height = '0px';
        values.style.marginTop = '0px';
      }

      const slideObserver = new MutationObserver(() => {
        const computedHeight = values.getBoundingClientRect().height;
        values.style.transition = 'none';
        values.style.height = computedHeight + 'px';

        if (key.classList.contains('LeeepSearchFilterItemOpen')) {
          const targetHeight = values.scrollHeight + 'px';
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';
              values.style.height = targetHeight;
              values.style.marginTop = '24px';
              values.addEventListener('transitionend', () => {
                if (key.classList.contains('LeeepSearchFilterItemOpen')) {
                  values.style.height = 'auto';
                }
              }, { once: true });
            });
          });
        } else {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              values.style.transition = 'height 0.3s ease, margin-top 0.3s ease';
              values.style.height = '0px';
              values.style.marginTop = '0px';
            });
          });
        }
      });
      slideObserver.observe(key, { attributes: true, attributeFilter: ['class'] });
    });
  }
});
